import React from 'react';
import { BaseText } from '@ui';

const settings = {
  standard: {
    fontSize: '14px',
    lineHeight: '20px',
  },
  small: {
    fontSize: '12px',
    lineHeight: '16px',
  },
};

export default function Body4(props) {
  return (
    <BaseText settings={settings} {...props}>
      <p>{props.children}</p>
    </BaseText>
  );
}
